import 'css-chunksrc/client/scenes/costRemoval/styles.scss';export default {
  "header": "_header_145us_1",
  "group": "_group_145us_5",
  "text": "_text_145us_9",
  "name": "_name_145us_14",
  "main": "_main_145us_20",
  "buttons": "_buttons_145us_27"
};